<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>{{HeaderTitle}}</ion-title>

        <ion-button title="fechar" style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end"
            (click)="Close($event)">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

    <div class="subtitle-banner" *ngIf="Subtitle">
        <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
        <p>{{Subtitle}}</p>
    </div>

    <ion-grid class="full ion-no-margin ion-no-padding">
        <form [formGroup]="Form">
            <ion-row>

                <ion-col size="12" *ngIf="ReportTypes?.length > 1">
                    <ion-item class="full" lines="full" fill="outline">
                        <ion-label position="stacked" i18n=":@@modal_report_export.report-type">Tipo de Relatório
                        </ion-label>
                        <ion-select class="outline" interface="popover" formControlName="ReportType">
                            <ion-select-option [value]="item?.Id"
                                *ngFor="let item of ReportTypes">{{item?.Name||'--'}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                </ion-col>

                <ng-container *ngFor="let field of Fields">

                    <ion-col size="12" sizeMd="6" [ngSwitch]="field.type">

                        <ion-item class="full" lines="full" fill="outline" *ngSwitchCase="'text'">
                            <ion-label position="stacked">{{field.label}}</ion-label>
                            <ion-input [formControlName]="field.key"></ion-input>
                        </ion-item>

                        <ion-item class="full" lines="full" fill="outline" *ngSwitchCase="'select'">
                            <ion-label position="stacked">{{field.label}}</ion-label>
                            <ion-select class="outline" interface="popover" [formControlName]="field.key">
                                <ion-select-option *ngIf="field.allowAll" [value]="''"
                                    i18n=":@@modal_report_export.all">Todos
                                </ion-select-option>
                                <ion-select-option [value]="item?.Id"
                                    *ngFor="let item of field.options">{{item?.Name||'--'}}</ion-select-option>
                            </ion-select>
                        </ion-item>

                        <ng-container *ngSwitchCase="'age'">

                            <ion-grid class="ion-no-margin ion-no-padding">
                                <ion-row>
                                    <ion-col style="max-width: 90px;" class="ion-no-padding ion-padding-end">
                                        <ion-item lines="none" fill="outline">
                                            <ion-label position="stacked">{{field.label}}</ion-label>
                                            <ion-input class="outline" type="number" [formControlName]="field.key"
                                                min="0"></ion-input>
                                        </ion-item>
                                    </ion-col>
                                    <ion-col class="ion-no-padding">
                                        <ion-item lines="none" fill="outline">
                                            <ion-label position="stacked"
                                                i18n=":@@modal_report_export.order">Ordenação</ion-label>
                                            <ion-buttons>
                                                <ion-button [title]="'Ordenação'" fill="outline" color="medium"
                                                    (click)="ToggleOrder(field)">
                                                    <ion-icon slot="icon-only"
                                                        [name]="Form.get(field.key+'OrderDescending')?.value ? 'arrow-down-outline' : 'arrow-up-outline'"></ion-icon>
                                                </ion-button>
                                            </ion-buttons>
                                        </ion-item>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>

                        </ng-container>

                    </ion-col>

                </ng-container>

            </ion-row>
        </form>
    </ion-grid>

</ion-content>

<ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
        <ion-button style="margin-right: -16px;" slot="end" fill="solid" color="medium"
            i18n=":@@modal_report_export.submit" (click)="OnConfirm($event)">Exportar
        </ion-button>
    </ion-toolbar>
</ion-footer>
